import React, { useState, useEffect } from 'react'
import { Button, TextField, Autocomplete } from '@mui/material'
import { useGeneralData } from '../hooks/useGeneralData'
import { useGeneral } from '../../../context/general'
import styles from './ManageDatasetsPermissions.module.scss'
import axios from 'axios'

export default function ManageDatasetsPermissions(){
    const [companiesToAccess, setcompaniesToAccess] = useState([])
    const [companyNames, setCompanyNames] = useState([])
    const [IsActive, setIsActive] = useState()
    const { setPopupAlert } = useGeneral()
    const [validity, setvalidity] = useState()

    const handleCompanyAccess = () => {        
        for (let company of companiesToAccess){
            // URL = '/api/ModifyCompanyAccess'
            // fetch(URL, {
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json' },
            //     body: JSON.stringify({
            //         company: company['name'],
            //         company_uuid: company['uuid'],
            //         is_active:IsActive,
            //         validity:validity
            //     })
            // })
            axios({
                method: 'POST',
                url: '/api/ModifyCompanyAccess',
                data: {
                    company: company['name'],
                    company_uuid: company['uuid'],
                    is_active:IsActive,
                    validity:validity
                }
            }).then(res => {
                res.status === 200 
                ? setPopupAlert('success', `Modified the ${company} details`)
                : setPopupAlert('error', `Something went wrong, ${company} details not modified`)
            })
        }

        setcompaniesToAccess([])
        setIsActive(null)
        setvalidity(null)
    }

    const getOptionLabel = (option) => option.name
    const renderInput = (params, label) => (<TextField {...params} label={`Choose ${label} to Modify access`} variant="outlined" />)
    const updatecompaniesToAccess = (e, value) => {setcompaniesToAccess(value)}
    const UpdateIsActive = (e,value) => setIsActive(value['value'])








    useEffect(() => {
        axios.get(`api/getCompanyNames`)
            .then(res => res.data)
            .then(res => setCompanyNames(res.company))
        return () => {}
    }, [])




    const options = [
        { label: 'True', value: true},
        { label: 'False', value: false },
    ]

    return (
        <>
            <div className={styles['autocompletes-container']}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={companyNames}
                    getOptionLabel={getOptionLabel}
                    style={{ width: 300 }}
                    renderInput={(params) => renderInput(params, 'users')}
                    value={companiesToAccess}
                    onChange={updatecompaniesToAccess}
                    loading={!!companyNames}
                />
                <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={options}
                    sx={{ width: 300 }}
                    renderInput={(params) => <TextField {...params} label="Active Status" />}
                    onChange={UpdateIsActive}
                />
                <TextField
                    id="outlined-basic" 
                    label="Validity -(DD/MM/YYYY)" 
                    variant="outlined"
                    value={validity}
                    placeholder="Validity -(DD/MM/YYYY)"
                    onChange={e => { setvalidity(e.target.value) }}
                    type="text"
                />
            </div>
            <div className={styles['submit']}><Button variant="contained" color="primary" onClick={handleCompanyAccess}> Submit </Button></div>
        </>
    )
}